export enum SupervisorAddUserColumns {
  name,
  role,
  assignments,
  isAdded,
}
